import { Component, input, output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-quantity-selector',
  imports: [TranslateModule, CommonModule],
  templateUrl: './quantity-selector.html',
  styleUrl: './quantity-selector.css',
})
export class QuantitySelector {
  qty = input.required<number>();
  variant = input<'mobile' | 'desktop'>('desktop');
  itemId = input.required<string>();

  isCheckout = input(false);
decrease = output<string>();
increase = output<string>();
}
